import React from "react";
import { ResourceEnum } from "src/constants/constants.ts";
import type { ModuleOptions } from "src/system/module.types.ts";
import type { AccountingBookingRuleResource } from "@exonn/js-sdk";

/**
 * Booking rules per owner (S6b, A18): manual and learned. Rules propose; a person books.
 */
export const module: ModuleOptions<AccountingBookingRuleResource> = {
  resource: ResourceEnum.AccountingBookingRule,
  bigIcon: <span className={"icon-20-book-alt"} />,
  smallIcon: <span className={"icon-15-book-alt"} />,
  tabs: {
    edit: {
      getTitle: (resource) => resource.title,
    },
  },
};
